export enum ScenarioModifyErrorHintIds {
  EMPTY_INPUT = 'empty-input',
  NEGATIVE_INPUT = 'negative-input',
  IS_NAN = 'is-Nan',
  NON_POSITIVE = 'non-positive',
  PERCENT_OVER_100 = 'percent-over-100',
  EXCEEDS_PROJECT_LIFETIME = 'exceeds-project-lifetime',
  SMALL_LOAN_DURATION = 'small-loan-duration'
}
